export enum ButtonType {
  BASIC = 0,
  LEADING_ADD_ICON = 1,
  TRAILING_LINK_ICON = 2,
  TRAILING_OPEN_ICON = 3,
}
